import { jsx as n } from "react/jsx-runtime";
import { forwardRef as a } from "react";
const i = ({
  event: o,
  onClick: t,
  shouldDisableStopPropagation: r
}) => {
  const u = o.preventDefault, l = o.stopPropagation;
  try {
    o.preventDefault = () => {
    }, r && (o.stopPropagation = () => {
    }), t == null || t(o);
  } finally {
    o.preventDefault = u, o.stopPropagation = l;
  }
}, f = a(function(o, t) {
  return /* @__PURE__ */ n(
    "button",
    {
      ref: t,
      ...o,
      onClick: (r) => i({
        event: r,
        onClick: o.onClick
      })
    }
  );
}), c = a(
  function(o, t) {
    return /* @__PURE__ */ n(
      "div",
      {
        ref: t,
        ...o,
        onClick: (r) => i({
          event: r,
          onClick: o.onClick,
          shouldDisableStopPropagation: !0
        })
      }
    );
  }
);
export {
  f as TooltipCustomButton,
  c as TooltipCustomDiv
};
